import { CatalogGridItem } from '@/types/Catalogs'
import { SortDirection } from '../Support'
import { License } from './Licenses'

export enum DeviceStatus {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
  resettle = 'RESETTLE'
}

export class DeviceCatalogGridItem extends CatalogGridItem {
  name: string
  status: string
  uuid: string
  user: string
  activeLicenses: License[] = []
  creation: string
  update: string
  loading: boolean
}

export class Device {
  id: number
  name: string
  status: DeviceStatus
  uuid: string
  creationDate: Date
  updateDate: Date
  appVersion: string
  osVersion: string

  static getInstanceForEdit () {
    const instance = new Device()
    instance.name = ''
    instance.status = DeviceStatus.active
    instance.uuid = ''
    instance.creationDate = new Date()
    instance.updateDate = new Date()
    return instance
  }

  static getStatus (status: DeviceStatus) {
    switch (status) {
      case DeviceStatus.active:
        return 'Activo'
      case DeviceStatus.inactive:
        return 'Inactivo'
      case DeviceStatus.resettle:
        return 'Restablecido'
      default:
        return '---'
    }
  }
}

export class DeviceCatalogFilters {
  name: string | undefined
  uuid: string | undefined
  status: DeviceStatus | undefined
  sort: string = 'name'
  sortOrder: SortDirection = SortDirection.ASC
}
